"use strict";

module.exports = require("./is-implemented")()
	? Array.from
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/array/from/index.js
// module id = 125
// module chunks = 0